import RiskAssessmentContainer from "./RiskAssessmentContainer";
import RiskAssessmentStore from "./RiskAssessmentStore";

export default RiskAssessmentStore(RiskAssessmentContainer);